import { Box } from '@mui/material';
import React from 'react';
import { AutocompleteArrayInput, BooleanInput, ReferenceArrayInput, SelectArrayInput, useTranslate } from 'react-admin';
import { filterToQuery } from '../../../utils';

const FormPlaceAndFuel: React.FC<{ formData?: any }> = ({ formData }) =>  {
  const translate = useTranslate();

  return (
    <Box sx={{ display: 'inline-grid' }}>
      <BooleanInput source="selectsAllPlaces" label="Selecionar todos os postos" />
      {
        !formData.selectsAllPlaces &&
        <ReferenceArrayInput
          style={{ minWidth: 260 }}
          sort={{ field: 'name', order: 'ASC' }}
          perPage={null}
          source="stationIds"
          reference="chains/chainId/stations"
        >
          <AutocompleteArrayInput 
            filterToQuery={filterToQuery} 
            label="Postos" 
            optionText="name" 
            sx={{ minWidth: 260, '& .MuiAutocomplete-inputRoot .MuiAutocomplete-input': { minWidth: 50 } }}
            noOptionsText={translate('ra.input.autocomplete.no_options_text')}        
          />
        </ReferenceArrayInput>
      }
  
      <BooleanInput source="selectsAllFuels" label="Selecionar todos os combustíveis" />
      {
        !formData.selectsAllFuels &&
        <ReferenceArrayInput
          style={{ minWidth: 260 }}
          sort={{ field: 'name', order: 'ASC' }}
          perPage={null}
          source="fuelIds"
          reference="fuels"
        >
          <SelectArrayInput label="Combustíveis" optionText="name" />
        </ReferenceArrayInput>
      }
    </Box>
  );
};

export default FormPlaceAndFuel;